import React from 'react'
import { Link as RouterLink } from 'react-router-dom'
import { Link } from '@mui/material'

import { useReferrerState } from 'hooks'
import { competitorProfilePath } from 'routes'

/**
 * VRG-744 — a competitor's name, linked to its profile on Competitor research. Every surface that
 * names a competitor (the research tabs, GTM → SEO Rankings and Gap finder) uses this, so a profile
 * has one address. Carries the referrer (§42), so the profile offers "← Back to" the surface the
 * reader came from.
 */
export const CompetitorLink = ({
  domain,
  name,
  children,
  strong = false,
}: {
  domain: string
  name?: string | null
  children?: React.ReactNode
  strong?: boolean
}) => {
  const referrer = useReferrerState()
  return (
    <Link
      component={RouterLink}
      to={competitorProfilePath(domain)}
      state={referrer}
      underline="hover"
      color="inherit"
      sx={{ fontWeight: strong ? 600 : 'inherit' }}
    >
      {children ?? (name?.trim() || domain)}
    </Link>
  )
}
